"use server"

import { PII } from "@/shared/constants/backend-api"
import { REQUEST_TYPE } from "@/shared/types/action-helper.type"
import { executeApiRequest } from "@/shared/lib/helpers/actions.helpers"
import { ApiResponse } from "@/shared/types/backend-response.type"

export type RevealPiiResponse = {
    field: string
    value: string | null
}

/**
 * Reveal an unmasked Tier 2 PII field for a volunteer.
 *
 * **Authorized users only (Admin, GroupLeader, TeamLeader with active access).**
 * Each call is logged in the backend's `pii_audit_log` table for compliance.
 *
 * @param volunteerId - The volunteer's ID (from volunteer record, not user ID)
 * @param fieldName - The PII field name to reveal (e.g. 'passportNumber', 'dateOfBirth')
 */
export async function revealPiiField(
    volunteerId: number,
    fieldName: string,
): Promise<ApiResponse<RevealPiiResponse>> {
    const url = PII.reveal(volunteerId, fieldName)
    return executeApiRequest<RevealPiiResponse>({
        url,
        method: REQUEST_TYPE.get,
        options: { cache: "no-store" },
    })
}
